(() => {
  "use strict";
  const A = window.Avenger;
  if (!A) return;
  class Header extends HTMLElement {
    connectedCallback() {
      if (!this.firstElementChild) {
        queueMicrotask(() => {
          if (this.isConnected && this.firstElementChild)
            this.connectedCallback();
        });
        return;
      }
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.baseY = this.getBoundingClientRect().top + scrollY;
      this.wrapper = this.closest(".shopify-section");
      this.lastY = scrollY;
      this.direction = 0;
      this.travel = 0;
      this.drawer = this.querySelector(".av-header__drawer, :scope > dialog");
      this.trigger = this.querySelector("[data-menu-open]");
      if (this.trigger) this.trigger.hidden = false;
      this.trigger?.addEventListener(
        "click",
        () => {
          this.closeDropdowns();
          this.drawer.showModal();
          this.update();
          this.trigger.setAttribute("aria-expanded", "true");
        },
        { signal },
      );
      this.querySelector("[data-menu-close]")?.addEventListener(
        "click",
        () => this.closeDrawer(),
        { signal },
      );
      this.drawer?.addEventListener(
        "cancel",
        (e) => {
          e.preventDefault();
          this.closeDrawer();
        },
        { signal },
      );
      this.drawer?.addEventListener(
        "click",
        (e) => {
          if (e.target !== this.drawer) return;
          const r = this.drawer.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right) this.closeDrawer();
        },
        { signal },
      );
      this.drawer?.addEventListener(
        "close",
        () => this.trigger?.setAttribute("aria-expanded", "false"),
        { signal },
      );
      this.resize = new ResizeObserver(() => {
        document.documentElement.style.setProperty(
          "--av-header-height",
          `${this.getBoundingClientRect().height}px`,
        );
        this.sizeSearch();
        this.update();
      });
      this.resize.observe(this);
      this.addEventListener(
        "toggle",
        (e) => {
          if (!(e.target instanceof HTMLDetailsElement) || !e.target.open)
            return;
          this.querySelectorAll(
            ".av-header__desktop-nav details[open], .av-account-menu[open]",
          ).forEach((d) => {
            if (d !== e.target && !d.contains(e.target)) this.closeDropdown(d);
          });
          this.animateDropdown(e.target);
          this.place(e.target);
          this.update();
        },
        { capture: true, signal },
      );
      this.hoverTimer = null;
      this.addEventListener(
        "pointerover",
        (e) => {
          if (
            this.dataset.menuTrigger === "click" ||
            e.pointerType !== "mouse" ||
            !matchMedia("(min-width: 990px)").matches
          )
            return;
          const item = e.target.closest(
            ".av-header__desktop-nav .av-nav__item",
          );
          const detail = item?.querySelector("details");
          if (!detail) return;
          clearTimeout(this.hoverTimer);
          clearTimeout(this.hoverCloseTimer);
          if (detail.open && !detail.classList.contains("is-closing")) return;
          this.hoverTimer = setTimeout(() => this.openDropdown(detail), 80);
        },
        { signal },
      );
      this.addEventListener(
        "pointerout",
        (e) => {
          if (this.dataset.menuTrigger === "click" || e.pointerType !== "mouse")
            return;
          const item = e.target.closest(".av-nav__item");
          if (item && !item.contains(e.relatedTarget)) {
            clearTimeout(this.hoverTimer);
            const detail = item.querySelector("details");
            if (detail && !detail.contains(document.activeElement)) {
              clearTimeout(this.hoverCloseTimer);
              this.hoverCloseTimer = setTimeout(
                () => this.closeDropdown(detail),
                200,
              );
            }
          }
        },
        { signal },
      );
      this.addEventListener(
        "keydown",
        (e) => {
          if (e.key !== "Escape") return;
          const detail = e.target.closest("details[open]");
          if (detail) {
            e.preventDefault();
            detail.open = false;
            detail.querySelector("summary").focus();
          }
        },
        { signal },
      );
      this.addEventListener(
        "click",
        (event) => {
          const summary = event.target.closest(
            ".av-nav--desktop details > summary",
          );
          if (!summary || !summary.parentElement.hasAttribute("data-dropdown"))
            return;
          event.preventDefault();
          const detail = summary.parentElement;
          if (detail.open && !detail.classList.contains("is-closing"))
            this.closeDropdown(detail);
          else this.openDropdown(detail);
        },
        { signal },
      );
      this.addEventListener(
        "click",
        (event) => {
          const trigger = event.target.closest("[data-search-trigger]");
          if (
            !trigger ||
            this.dataset.searchMode !== "expand" ||
            !matchMedia("(min-width: 990px)").matches
          )
            return;
          event.preventDefault();
          event.stopPropagation();
          this.toggleSearch(trigger);
        },
        { signal },
      );
      this.addEventListener(
        "keydown",
        (event) => {
          if (
            event.key === "Escape" &&
            this.classList.contains("is-search-open")
          ) {
            event.preventDefault();
            this.closeSearch();
            this.querySelector("[data-search-trigger]")?.focus({
              preventScroll: true,
            });
          }
        },
        { signal },
      );
      document.addEventListener(
        "click",
        (e) => {
          if (!this.contains(e.target)) {
            this.closeDropdowns();
            this.closeSearch();
          }
        },
        { signal },
      );
      this.addEventListener(
        "focusout",
        (e) => {
          // Hiding the expanding-search trigger can temporarily move focus to
          // the document body. Only an actual focus destination dismisses it.
          if (
            !e.relatedTarget ||
            e.relatedTarget === document.body ||
            e.relatedTarget === document.documentElement
          )
            return;
          queueMicrotask(() => {
            if (
              this.isConnected &&
              !this.searchOpening &&
              !this.contains(document.activeElement)
            ) {
              this.closeDropdowns();
              this.closeSearch();
            }
          });
        },
        { signal },
      );
      addEventListener("scroll", () => this.update(), {
        passive: true,
        signal,
      });
      addEventListener(
        "resize",
        () => {
          if (innerWidth >= 990) this.closeDrawer();
          else this.closeSearch();
          this.syncSearchMode();
          this.sizeSearch();
          this.querySelectorAll("details[open]").forEach((d) => this.place(d));
        },
        { signal },
      );
      document.addEventListener("av:panel-open", () => this.update(), {
        signal,
      });
      document.addEventListener("av:panel-close", () => this.update(), {
        signal,
      });
      this.addEventListener("focusin", () => this.update(), { signal });
      document.addEventListener(
        "shopify:block:select",
        (event) => {
          const blockId = event.detail?.blockId;
          if (!blockId) return;
          const desktop = matchMedia("(min-width: 990px)").matches;
          const detail = [
            ...this.querySelectorAll("details[data-av-mega-block]"),
          ].find(
            (item) =>
              item.dataset.avMegaBlock === blockId &&
              !!item.closest(".av-nav--desktop") === desktop,
          );
          if (!detail) return;
          this.closeDropdowns();
          if (!desktop && this.drawer && !this.drawer.open) {
            clearTimeout(this.drawerTimer);
            this.drawer.classList.remove("is-closing");
            this.drawer.showModal();
            this.trigger?.setAttribute("aria-expanded", "true");
            this.editorOpenedDrawer = true;
          }
          this.editorMega = detail;
          detail.open = true;
          this.place(detail);
          this.update();
        },
        { signal },
      );
      document.addEventListener(
        "shopify:block:deselect",
        (event) => {
          if (
            !this.editorMega ||
            this.editorMega.dataset.avMegaBlock !== event.detail?.blockId
          )
            return;
          this.editorMega.open = false;
          this.editorMega = null;
          if (this.editorOpenedDrawer) this.closeDrawer();
          this.editorOpenedDrawer = false;
          this.update();
        },
        { signal },
      );
      document.addEventListener(
        "av:page",
        () => {
          this.wrapper.classList.remove("av-header-hidden");
          this.update();
        },
        { signal },
      );
      if (this.querySelector("[data-desktop-search]"))
        this.querySelector("[data-desktop-search]").hidden = false;
      this.querySelectorAll("shopify-account").forEach((account) => {
        account.addEventListener(
          "open",
          () => {
            this.accountSheetOpen = true;
            this.update();
          },
          { signal },
        );
        account.addEventListener(
          "close",
          () => {
            this.accountSheetOpen = false;
            this.update();
          },
          { signal },
        );
      });
      this.syncSearchMode();
      this.update();
    }
    toggleSearch(trigger) {
      const search = this.querySelector("[data-desktop-search]");
      if (!search) return;
      const opening = !this.classList.contains("is-search-open");
      A.closePanels(true);
      this.searchOpening = opening;
      this.classList.toggle("is-search-open", opening);
      trigger.setAttribute("aria-expanded", String(opening));
      search.inert = !opening;
      if (opening) {
        search.hidden = false;
        this.sizeSearch();
        const input = search.querySelector("input");
        // Resolve the open-state styles before focusing, while the icon is
        // being hidden. Retry after layout without treating body focus as exit.
        search.getBoundingClientRect();
        input?.focus({ preventScroll: true });
        this.searchFocusFrame = requestAnimationFrame(() => {
          if (this.isConnected && this.classList.contains("is-search-open"))
            input?.focus({ preventScroll: true });
          this.searchOpening = false;
          this.searchFocusFrame = null;
        });
      }
      if (this.wrapper) this.update();
    }
    sizeSearch() {
      if (this.dataset.searchMode !== "expand" || innerWidth < 990) return;
      const search = this.querySelector("[data-desktop-search]");
      const inner = this.querySelector(".av-header__inner");
      const actions = this.querySelector(".av-header__actions");
      if (!search || !inner || !actions) return;
      const bounds = inner.getBoundingClientRect();
      if (!bounds.width) return;
      const brand =
        this.querySelector(".av-header__brand").getBoundingClientRect();
      const links = [
        ...this.querySelectorAll(".av-nav--desktop > .av-nav__item"),
      ];
      const rtl = getComputedStyle(this).direction === "rtl";
      const edge = rtl
        ? Math.min(
            brand.left,
            ...links.map((link) => link.getBoundingClientRect().left),
          )
        : Math.max(
            brand.right,
            ...links.map((link) => link.getBoundingClientRect().right),
          );
      const controls = [...actions.children].filter((node) =>
        node.matches(
          ".av-header__control:not([data-search-trigger]), shopify-account",
        ),
      );
      const trigger = this.querySelector("[data-search-trigger]");
      const actionBounds = actions.getBoundingClientRect();
      const triggerBounds = trigger.getBoundingClientRect();
      search.style.setProperty(
        "--av-header-search-end",
        `${rtl ? triggerBounds.left - actionBounds.left : actionBounds.right - triggerBounds.right}px`,
      );
      const occupied = controls.reduce(
        (width, node) => width + node.getBoundingClientRect().width,
        0,
      );
      const gap = parseFloat(getComputedStyle(actions).columnGap) || 0;
      const available =
        (rtl ? edge - bounds.left : bounds.right - edge) -
        occupied -
        gap * controls.length -
        24;
      search.style.setProperty(
        "--av-header-search-width",
        `${Math.max(120, Math.min(560, available))}px`,
      );
    }
    syncSearchMode() {
      const search = this.querySelector("[data-desktop-search]");
      const trigger = this.querySelector("[data-search-trigger]");
      if (!trigger || !search) return;
      const desktop = matchMedia("(min-width: 990px)").matches;
      const expand = desktop && this.dataset.searchMode === "expand";
      if (expand) trigger.removeAttribute("data-panel-open");
      else trigger.setAttribute("data-panel-open", "AvSearch");
      trigger.setAttribute("aria-controls", expand ? search.id : "AvSearch");
      search.inert =
        !desktop || (expand && !this.classList.contains("is-search-open"));
    }
    place(detail) {
      const panel = detail.querySelector(".av-menu-panel");
      if (!panel || !detail.closest(".av-nav--desktop")) return;
      const root = detail.closest(".av-nav__item");
      const headerRect = this.getBoundingClientRect();
      const anchor = root.getBoundingClientRect();
      if (["compact", "flyout"].includes(detail.dataset.mega)) {
        const width = Math.min(
          detail.dataset.mega === "flyout" ? 280 : 760,
          innerWidth - 32,
        );
        const left = Math.max(
          16,
          Math.min(anchor.left, innerWidth - width - 16),
        );
        panel.style.setProperty("--menu-left", `${left - headerRect.left}px`);
        panel.style.setProperty(
          "--menu-top",
          `${anchor.bottom - headerRect.top + 8}px`,
        );
        panel.style.setProperty("--menu-width", `${width}px`);
      }
      panel.style.removeProperty("--menu-offset");
      const rect = panel.getBoundingClientRect();
      const correction =
        rect.right > innerWidth - 16
          ? innerWidth - 16 - rect.right
          : rect.left < 16
            ? 16 - rect.left
            : 0;
      panel.style.setProperty("--menu-offset", `${correction}px`);
    }

    update() {
      const y = Math.max(0, scrollY),
        delta = y - this.lastY,
        direction = Math.sign(delta);
      if (direction && direction !== this.direction) this.travel = 0;
      this.travel += Math.abs(delta);
      this.direction = direction;
      this.lastY = y;
      const held =
        this.contains(document.activeElement) ||
        this.accountSheetOpen ||
        this.classList.contains("is-search-open") ||
        this.querySelector("details[open], dialog[open]") ||
        document.querySelector("av-panel dialog[open]");
      if (
        this.dataset.reveal === "true" &&
        this.dataset.sticky === "true" &&
        !held &&
        y > Number(this.dataset.threshold) &&
        this.travel > 12
      )
        this.wrapper.classList.toggle("av-header-hidden", direction > 0);
      if (held || y <= Number(this.dataset.threshold))
        this.wrapper.classList.remove("av-header-hidden");
      const hero = document.querySelector("[data-av-main] .av-hero");
      const transparent =
        !held &&
        this.dataset.transparent === "true" &&
        !!hero &&
        y < this.baseY + 24;
      this.wrapper.classList.toggle(
        "av-header-overlay",
        this.dataset.transparent === "true" && !!hero,
      );
      this.classList.toggle("is-transparent", transparent);
      this.classList.toggle("is-scrolled", y > Number(this.dataset.threshold));
    }
    closeDrawer(immediate = false) {
      if (!this.drawer?.open) return;
      this.drawer.classList.add("is-closing");
      clearTimeout(this.drawerTimer);
      const finish = () => {
        this.drawer.close();
        this.drawer.classList.remove("is-closing");
        this.trigger?.focus({ preventScroll: true });
      };
      if (immediate) finish();
      else this.drawerTimer = setTimeout(finish, A.duration(180));
    }
    closeSearch() {
      cancelAnimationFrame(this.searchFocusFrame);
      this.searchFocusFrame = null;
      this.searchOpening = false;
      const search = this.querySelector("[data-desktop-search]");
      if (search && this.dataset.searchMode === "expand")
        search.inert = matchMedia("(min-width: 990px)").matches;
      this.classList.remove("is-search-open");
      this.querySelector("[data-search-trigger]")?.setAttribute(
        "aria-expanded",
        "false",
      );
    }
    animateDropdown(detail) {
      const panel = detail.querySelector(".av-menu-panel");
      if (!panel || !detail.closest(".av-nav--desktop")) return;
      detail.avAnimation?.cancel();
      detail.classList.remove("is-closing");
      detail.avAnimation = panel.animate?.(
        [
          { opacity: 0, transform: "translateY(8px)" },
          { opacity: 1, transform: "translateY(0)" },
        ],
        { duration: A.duration(240), easing: "cubic-bezier(.22,1,.36,1)" },
      );
    }
    openDropdown(detail) {
      clearTimeout(this.hoverCloseTimer);
      const reopening = detail.open;
      detail.avAnimation?.cancel();
      detail.classList.remove("is-closing");
      this.querySelectorAll(
        ".av-nav--desktop details[open], .av-account-menu[open]",
      ).forEach((other) => {
        if (other !== detail) this.closeDropdown(other);
      });
      detail.open = true;
      if (reopening) this.animateDropdown(detail);
      this.place(detail);
      this.update();
    }
    closeDropdown(detail, immediate = false) {
      if (
        !detail.open ||
        (detail.classList.contains("is-closing") && !immediate)
      )
        return;
      detail.avAnimation?.cancel();
      const panel = detail.querySelector(".av-menu-panel");
      if (
        immediate ||
        !panel ||
        !detail.closest(".av-nav--desktop") ||
        !panel.animate
      ) {
        detail.open = false;
        detail.classList.remove("is-closing");
        return;
      }
      detail.classList.add("is-closing");
      const animation = (detail.avAnimation = panel.animate(
        [
          { opacity: 1, transform: "translateY(0)" },
          { opacity: 0, transform: "translateY(5px)" },
        ],
        { duration: A.duration(140), easing: "ease-in", fill: "forwards" },
      ));
      animation.finished
        .then(() => {
          if (detail.avAnimation !== animation) return;
          detail.open = false;
          detail.classList.remove("is-closing");
          animation.cancel();
          this.update();
        })
        .catch(() => {});
    }
    closeDropdowns() {
      clearTimeout(this.hoverTimer);
      clearTimeout(this.hoverCloseTimer);
      this.querySelectorAll("details[open]").forEach((detail) =>
        this.closeDropdown(detail, true),
      );
    }
    closeAll(immediate = false) {
      this.closeDropdowns();
      this.closeSearch();
      this.closeDrawer(immediate);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.searchFocusFrame);
      this.abort?.abort();
      this.resize?.disconnect();
      clearTimeout(this.drawerTimer);
      clearTimeout(this.hoverTimer);
      clearTimeout(this.hoverCloseTimer);
      this.querySelectorAll("details").forEach((detail) =>
        detail.avAnimation?.cancel(),
      );
      this.drawer?.close();
    }
  }
  customElements.define("avenger-header", Header);
  class Carousel extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = [...this.querySelectorAll("[data-slide]")].slice(0, 3);
      this.slides.slice(1).forEach((s) => {
        if (s.parentElement !== this) this.append(s);
      });
      const controls = this.querySelector("[data-carousel-controls]");
      if (controls) this.append(controls);
      this.index = 0;
      this.paused = this.dataset.autoplay !== "true";
      if (this.slides.length < 2) return;
      controls.hidden = false;
      const dots = this.querySelector("[data-slide-dots]");
      dots.replaceChildren();
      this.slides.forEach((s, i) => {
        const b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", `${i + 1}`);
        b.addEventListener("click", () => this.show(i), { signal });
        dots.append(b);
      });
      this.querySelector("[data-slide-next]")?.addEventListener(
        "click",
        () => this.show(this.index + 1),
        { signal },
      );
      this.querySelector("[data-slide-prev]")?.addEventListener(
        "click",
        () => this.show(this.index - 1),
        { signal },
      );
      this.querySelector("[data-slide-pause]")?.addEventListener(
        "click",
        () => {
          this.paused = !this.paused;
          this.schedule();
          this.updatePause();
        },
        { signal },
      );
      this.addEventListener("pointerenter", () => clearTimeout(this.timer), {
        signal,
      });
      this.addEventListener("pointerleave", () => this.schedule(), { signal });
      this.addEventListener("focusin", () => clearTimeout(this.timer), {
        signal,
      });
      this.addEventListener(
        "focusout",
        (e) => {
          if (!this.contains(e.relatedTarget)) this.schedule();
        },
        { signal },
      );
      document.addEventListener(
        "visibilitychange",
        () => {
          if (document.hidden) clearTimeout(this.timer);
          else this.schedule();
        },
        { signal },
      );
      this.addEventListener(
        "touchstart",
        (e) => (this.touchX = e.changedTouches[0].clientX),
        { passive: true, signal },
      );
      this.addEventListener(
        "touchend",
        (e) => {
          const dx = e.changedTouches[0].clientX - this.touchX;
          if (Math.abs(dx) > 60) this.show(this.index + (dx < 0 ? 1 : -1));
        },
        { passive: true, signal },
      );
      this.show(0);
      this.updatePause();
      document.addEventListener(
        "shopify:block:select",
        (e) => {
          const i = this.slides.findIndex(
            (s) => s.contains(e.target) || s === e.target,
          );
          if (i >= 0) {
            this.paused = true;
            this.show(i);
            this.updatePause();
          }
        },
        { signal },
      );
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      const content =
        this.slides[this.index].querySelector(".av-hero__content");
      const controls = this.querySelector("[data-carousel-controls]");
      if (content && controls) content.append(controls);
      this.slides.forEach((s, i) => {
        s.hidden = i !== this.index;
        if (i === this.index)
          s.animate(
            [
              { opacity: 0.3, transform: "translateY(8px)" },
              { opacity: 1, transform: "translateY(0)" },
            ],
            { duration: A.duration(360), easing: "ease-out" },
          );
      });
      this.querySelectorAll("[data-slide-dots] button").forEach((b, i) =>
        b.setAttribute("aria-current", String(i === this.index)),
      );
      this.schedule();
    }
    updatePause() {
      const b = this.querySelector("[data-slide-pause]");
      if (b)
        b.textContent = this.paused
          ? b.dataset.playLabel
          : b.dataset.pauseLabel;
    }
    schedule() {
      clearTimeout(this.timer);
      if (
        !this.paused &&
        !document.hidden &&
        !this.contains(document.activeElement)
      )
        this.timer = setTimeout(
          () => this.show(this.index + 1),
          Number(this.dataset.interval),
        );
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.timer);
    }
  }
  customElements.define("av-carousel", Carousel);
  class Announcements extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.key = `av-info-${this.dataset.id}`;
      try {
        const expiry =
          this.dataset.dismiss === "none"
            ? 0
            : Number(
                (this.dataset.dismiss === "day"
                  ? localStorage
                  : sessionStorage
                ).getItem(this.key),
              );
        if (expiry > Date.now()) {
          this.hidden = true;
          return;
        }
      } catch (_) {
        /* Storage can be disabled. */
      }
      this.items = [...this.querySelectorAll("[data-announcement]")];
      this.index = 0;
      this.querySelector("[data-announcement-close]")?.addEventListener(
        "click",
        () => {
          this.hidden = true;
          clearTimeout(this.timer);
          try {
            if (this.dataset.dismiss !== "none")
              (this.dataset.dismiss === "day"
                ? localStorage
                : sessionStorage
              ).setItem(
                this.key,
                String(
                  Date.now() +
                    (this.dataset.dismiss === "day" ? 86400000 : 31536000000),
                ),
              );
          } catch (_) {}
        },
        { signal },
      );
      this.addEventListener("pointerenter", () => clearTimeout(this.timer), {
        signal,
      });
      this.addEventListener("pointerleave", () => this.schedule(), { signal });
      this.addEventListener("focusin", () => clearTimeout(this.timer), {
        signal,
      });
      this.addEventListener("focusout", () => this.schedule(), { signal });
      document.addEventListener("visibilitychange", () => this.schedule(), {
        signal,
      });
      this.querySelectorAll("[data-announcement-step]").forEach((button) =>
        button.addEventListener(
          "click",
          () => {
            this.move(Number(button.dataset.announcementStep));
            this.schedule();
          },
          { signal },
        ),
      );
      this.schedule();
    }
    move(step) {
      if (this.items.length < 2) return;
      this.items[this.index].avAnimation?.cancel();
      this.index = (this.index + step + this.items.length) % this.items.length;
      this.items.forEach((item, index) => {
        item.hidden = index !== this.index;
        if (!item.hidden)
          item.avAnimation = item.animate?.(
            [
              { opacity: 0, transform: `translateX(${step > 0 ? 14 : -14}px)` },
              { opacity: 1, transform: "translateX(0)" },
            ],
            { duration: A.duration(280), easing: "cubic-bezier(.22,1,.36,1)" },
          );
      });
    }
    schedule() {
      clearTimeout(this.timer);
      if (
        this.items?.length > 1 &&
        !this.hidden &&
        !document.hidden &&
        !this.contains(document.activeElement)
      )
        this.timer = setTimeout(() => {
          this.move(1);
          this.schedule();
        }, Number(this.dataset.interval));
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.timer);
    }
  }
  customElements.define("av-announcements", Announcements);
  class Search extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.cache = new Map();
      this.input = this.querySelector('input[name="q"]');
      this.output = this.querySelector("[data-search-results]");
      this.index = -1;
      this.clearButton = this.querySelector("[data-search-clear]");
      const syncClear = () => {
        if (this.clearButton)
          this.clearButton.hidden =
            !this.input.value &&
            !this.classList.contains("av-header-search--expand");
      };
      this.clearButton?.addEventListener(
        "click",
        () => {
          clearTimeout(this.timer);
          this.requestAbort?.abort();
          this.input.value = "";
          this.output.replaceChildren();
          this.output.removeAttribute("aria-busy");
          this.classList.remove("has-results");
          this.input.removeAttribute("aria-activedescendant");
          this.input.setAttribute("aria-expanded", "false");
          syncClear();
          const header = this.closest("avenger-header");
          if (header && this.classList.contains("av-header-search--expand")) {
            header.closeSearch();
            header
              .querySelector("[data-search-trigger]")
              ?.focus({ preventScroll: true });
          } else this.input.focus({ preventScroll: true });
        },
        { signal },
      );
      this.input.addEventListener("input", syncClear, { signal });
      syncClear();
      this.addEventListener(
        "focusout",
        (e) => {
          if (
            !this.selectingResult &&
            e.relatedTarget &&
            e.relatedTarget !== document.body &&
            e.relatedTarget !== document.documentElement &&
            !this.contains(e.relatedTarget)
          ) {
            this.classList.remove("has-results");
            this.input.setAttribute("aria-expanded", "false");
          }
        },
        { signal },
      );
      this.output.addEventListener(
        "pointerdown",
        (event) => {
          this.selectingResult = true;
          if (
            event.pointerType === "mouse" &&
            event.target.closest("[data-search-option]")
          )
            event.preventDefault();
        },
        { signal },
      );
      window.addEventListener(
        "pointerup",
        () => {
          requestAnimationFrame(() => {
            this.selectingResult = false;
          });
        },
        { signal },
      );
      window.addEventListener(
        "pointercancel",
        () => {
          this.selectingResult = false;
        },
        { signal },
      );
      document.addEventListener(
        "click",
        (event) => {
          if (!event.composedPath().includes(this)) {
            this.classList.remove("has-results");
            this.input.setAttribute("aria-expanded", "false");
          }
        },
        { signal },
      );
      this.input.addEventListener(
        "focus",
        () => {
          if (this.input.value.trim()) this.classList.add("has-results");
        },
        { signal },
      );
      this.input.addEventListener(
        "input",
        () => {
          clearTimeout(this.timer);
          this.requestAbort?.abort();
          this.index = -1;
          this.timer = setTimeout(() => this.search(), 200);
        },
        { signal },
      );
      this.input.addEventListener(
        "keydown",
        (e) => {
          const links = [
            ...this.output.querySelectorAll("a[data-search-option]"),
          ];
          if (e.key === "Escape") {
            this.output.replaceChildren();
            this.classList.remove("has-results");
            this.input.setAttribute("aria-expanded", "false");
          }
          if (["ArrowDown", "ArrowUp"].includes(e.key) && links.length) {
            e.preventDefault();
            this.index =
              (this.index + (e.key === "ArrowDown" ? 1 : -1) + links.length) %
              links.length;
            links.forEach((n, i) => {
              n.classList.toggle("is-selected", i === this.index);
              n.setAttribute("aria-selected", String(i === this.index));
            });
            this.input.setAttribute(
              "aria-activedescendant",
              links[this.index].id,
            );
            links[this.index].scrollIntoView({ block: "nearest" });
          }
          if (e.key === "Enter" && this.index >= 0 && links[this.index]) {
            e.preventDefault();
            links[this.index].click();
          }
        },
        { signal },
      );
    }
    async search() {
      const page = this.closest("av-search-page");
      if (page && page.dataset.suggestions === "false") return;
      const q = this.input.value.trim();
      this.input.removeAttribute("aria-activedescendant");
      this.querySelector("[data-search-all]").href =
        `${A.config.search}?q=${encodeURIComponent(q)}`;
      if (!q) {
        this.output.replaceChildren();
        this.classList.remove("has-results");
        this.input.setAttribute("aria-expanded", "false");
        return;
      }
      this.requestAbort = new AbortController();
      const signal = this.requestAbort.signal;
      this.classList.add("has-results");
      const types = (
        typeof A.config.searchTypes === "string"
          ? A.config.searchTypes.split(",")
          : ["product", "collection", "page", "article"]
      ).filter((type) =>
        ["product", "collection", "page", "article"].includes(type),
      );
      if (!types.length) {
        this.output.textContent = A.strings.noResults;
        this.output.removeAttribute("aria-busy");
        this.input.setAttribute("aria-expanded", "true");
        return;
      }
      this.output.innerHTML = types
        .map(
          (type) =>
            `<div class="av-search-skeleton-group" aria-hidden="true"><i class="av-search-skeleton-heading"></i>${Array.from({ length: type === "product" ? 3 : 1 }, () => `<div class="av-search-skeleton-row">${type === "product" ? '<i class="av-search-skeleton-image"></i>' : ""}<span><i></i><i></i></span></div>`).join("")}</div>`,
        )
        .join("");
      this.output.setAttribute("aria-busy", "true");
      try {
        let html = this.cache.get(q);
        if (!html) {
          const url = `${A.config.predictive}?q=${encodeURIComponent(q)}&resources[type]=${types.join(",")}&resources[limit]=${Math.max(2, Math.min(6, Number(A.config.searchLimit) || 3))}&resources[limit_scope]=each&section_id=predictive-search`;
          html = await (await A.request(url, { signal })).text();
          this.cache.set(q, html);
          if (this.cache.size > 12)
            this.cache.delete(this.cache.keys().next().value);
        }
        if (signal.aborted || q !== this.input.value.trim()) return;
        const doc = new DOMParser().parseFromString(html, "text/html");
        this.output.replaceChildren(
          ...(doc.querySelector("[data-predictive-content]")?.childNodes || []),
        );
        if (!this.output.children.length)
          this.output.textContent = A.strings.noResults;
        this.output
          .querySelectorAll("[data-search-option]")
          .forEach((n, i) => (n.id = `${this.input.id}-result-${i}`));
        if (page) {
          const suggestions = [
            ...this.output.querySelectorAll("[data-search-option]"),
          ]
            .slice(0, 5)
            .map((link, index) => {
              const title =
                link.querySelector(".av-search-result-copy > span")
                  ?.textContent ||
                link.querySelector(".av-search-result-copy")?.textContent ||
                link.textContent;
              link.textContent = title.trim();
              const url = new URL(A.config.search, location.origin);
              url.searchParams.set("q", title.trim());
              link.href = url.href;
              link.id = `${this.input.id}-result-${index}`;
              return link;
            });
          this.output.replaceChildren(...suggestions);
        }
        this.input.setAttribute("aria-expanded", "true");
      } catch (error) {
        if (error.name !== "AbortError") {
          this.output.replaceChildren();
          const p = document.createElement("p");
          p.textContent = error.message;
          const b = document.createElement("button");
          b.type = "button";
          b.textContent = A.strings.retry;
          b.addEventListener("click", () => this.search(), { once: true });
          this.output.append(p, b);
        }
      } finally {
        if (!signal.aborted) this.output.setAttribute("aria-busy", "false");
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.requestAbort?.abort();
      clearTimeout(this.timer);
    }
  }
  customElements.define("av-search", Search);
  const wishlist = (A.wishlist = {
    items: [],
    read() {
      try {
        const value = JSON.parse(
          localStorage.getItem("avenger-wishlist") || "[]",
        );
        this.items = Array.isArray(value)
          ? value
              .filter((x) => typeof x === "string" && /^[a-z0-9-]+$/.test(x))
              .slice(0, 100)
          : [];
      } catch (_) {
        this.items = [];
      }
    },
    emit() {
      document.querySelectorAll("[data-wishlist-count]").forEach((n) => {
        n.textContent = this.items.length;
        n.hidden = !this.items.length;
      });
      document.querySelectorAll("[data-wishlist-handle]").forEach((n) => {
        const saved = this.items.includes(n.dataset.wishlistHandle);
        n.setAttribute("aria-pressed", String(saved));
        n.setAttribute("aria-label", saved ? A.strings.saved : A.strings.save);
      });
      document
        .querySelectorAll("[data-wishlist-full]")
        .forEach((n) => (n.hidden = !this.items.length));
      document.dispatchEvent(new CustomEvent("av:wishlist"));
    },
    toggle(handle) {
      if (!/^[a-z0-9-]+$/.test(handle)) return;
      this.items = this.items.includes(handle)
        ? this.items.filter((h) => h !== handle)
        : [handle, ...this.items].slice(0, 100);
      try {
        localStorage.setItem("avenger-wishlist", JSON.stringify(this.items));
      } catch (_) {
        A.announce(A.strings.error);
      }
      this.emit();
    },
  });
  wishlist.read();
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-wishlist-handle]");
    if (b) {
      e.preventDefault();
      wishlist.toggle(b.dataset.wishlistHandle);
      b.avSaveAnimation?.cancel?.();
      b.avSaveAnimation = b.animate?.(
        [
          { transform: "scale(1)" },
          { transform: "scale(1.2)" },
          { transform: "scale(1)" },
        ],
        { duration: A.duration(320), easing: "cubic-bezier(.22,1,.36,1)" },
      );
    }
  });
  addEventListener("storage", (e) => {
    if (e.key === "avenger-wishlist") {
      wishlist.read();
      wishlist.emit();
    }
  });
  document.addEventListener("av:page", () => wishlist.emit());
  class Wishlist extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      document.addEventListener("av:wishlist", () => this.render(), {
        signal: this.abort.signal,
      });
      this.render();
    }
    async render() {
      this.requestAbort?.abort();
      this.requestAbort = new AbortController();
      const signal = this.requestAbort.signal;
      const handles = wishlist.items.slice(0, Number(this.dataset.limit || 3));
      this.productCache ||= new Map();
      if (!handles.length) {
        this.textContent = A.strings.empty;
        this.setAttribute("aria-busy", "false");
        return;
      }
      if (!this.children.length)
        this.innerHTML = '<div class="av-skeleton"></div>';
      this.setAttribute("aria-busy", "true");
      const products = await Promise.allSettled(
        handles.map((h) => {
          const cached = this.productCache.get(h);
          if (cached && Date.now() - cached.at < 60000)
            return Promise.resolve(cached.product);
          return A.request(`${A.root}products/${encodeURIComponent(h)}.js`, {
            signal,
          })
            .then((r) => r.json())
            .then((product) => {
              if (!signal.aborted)
                this.productCache.set(h, { product, at: Date.now() });
              return product;
            });
        }),
      );
      if (signal.aborted) return;
      this.setAttribute("aria-busy", "false");
      this.replaceChildren();
      products.forEach((result, i) => {
        const row = document.createElement("article");
        row.className = "av-wishlist-row";
        const a = document.createElement("a");
        a.href = `${A.root}products/${handles[i]}`;
        if (result.status === "fulfilled") {
          const product = result.value;
          if (product.featured_image) {
            const img = document.createElement("img");
            img.src = product.featured_image;
            img.alt = product.title;
            img.loading = "lazy";
            img.width = 80;
            img.height = 100;
            a.append(img);
          }
          const text = document.createElement("span");
          text.textContent = `${product.title} · ${A.money(product.price)}`;
          a.append(text);
        } else a.textContent = handles[i];
        const button = document.createElement("button");
        button.type = "button";
        button.className = "av-icon-button";
        button.textContent = "×";
        button.setAttribute("aria-label", A.strings.remove);
        button.addEventListener("click", async () => {
          button.disabled = true;
          const animation = row.animate?.(
            [
              { opacity: 1, height: `${row.getBoundingClientRect().height}px` },
              {
                opacity: 0,
                height: "0px",
                paddingBlock: "0px",
                marginBlock: "0px",
              },
            ],
            { duration: A.duration(220), easing: "ease", fill: "forwards" },
          );
          await animation?.finished?.catch(() => {});
          if (wishlist.items.includes(handles[i])) wishlist.toggle(handles[i]);
        });
        row.append(a, button);
        this.append(row);
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.requestAbort?.abort();
    }
  }
  customElements.define("av-wishlist", Wishlist);
  wishlist.emit();
  class Product extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.gallery = this.querySelector(".av-product-gallery--editorial");
      this.galleryMore = this.querySelector("[data-gallery-more]");
      if (this.gallery && this.galleryMore) {
        this.gallery.classList.add("is-gallery-preview");
        if (!this.gallery.classList.contains("is-gallery-expanded")) this.galleryMore.hidden = false;
        this.galleryMore.addEventListener("click", () => this.expandMobileGallery(), { signal });
      }
      if (this.gallery) {
        this.galleryScrollY = scrollY;
        this.galleryTop = null;
        const updateGallery = () => {
          if (this.galleryFrame) return;
          this.galleryFrame = requestAnimationFrame(() => {
            this.galleryFrame = null;
            this.updateGallerySticky();
          });
        };
        window.addEventListener("scroll", updateGallery, {
          passive: true,
          signal,
        });
        window.addEventListener("resize", updateGallery, { signal });
        if (window.ResizeObserver) {
          this.galleryResize = new ResizeObserver(updateGallery);
          this.galleryResize.observe(this.gallery);
        }
        this.updateGallerySticky();
      }

      this.variants = JSON.parse(
        this.querySelector("[data-variants]").textContent,
      );
      this.form = this.querySelector("[data-product-form]");
      this.select = this.form.querySelector('[name="id"]');
      this.select.addEventListener("change", () => this.selectVariant(), {
        signal,
      });
      const choices = this.querySelector(".av-variant-choices");
      if (choices) {
        choices.hidden = false;
        this.classList.add("has-variant-controls");
        choices.addEventListener(
          "change",
          (event) => {
            const input = event.target.closest("[data-variant-choice]");
            if (!input || input.disabled) return;
            this.select.value = input.value;
            this.select.dispatchEvent(new Event("change", { bubbles: true }));
          },
          { signal },
        );
      }
      this.querySelector("[data-sticky-variant]")?.addEventListener(
        "change",
        (event) => {
          if (this.select.value === event.target.value) return;
          this.select.value = event.target.value;
          this.select.dispatchEvent(new Event("change", { bubbles: true }));
        },
        { signal },
      );
      this.form.elements.selling_plan?.addEventListener(
        "change",
        () => this.selectVariant(),
        { signal },
      );
      this.querySelectorAll("[data-gallery-target]").forEach((b) =>
        b.addEventListener(
          "click",
          () => this.showMedia(b.dataset.galleryTarget),
          { signal },
        ),
      );
      this.addEventListener(
        "click",
        (event) => {
          const quantityButton = event.target.closest(
            "[data-product-quantity]",
          );
          if (quantityButton) {
            const input = this.form.elements.quantity;
            const min = Number(input.min) || 1,
              step = Number(input.step) || 1;
            const value =
              min +
              Math.round((Number(input.value || min) - min) / step) * step;
            input.value = Math.max(
              min,
              Math.min(
                input.max ? Number(input.max) : Infinity,
                value + Number(quantityButton.dataset.productQuantity) * step,
              ),
            );
            input.dispatchEvent(new Event("change", { bubbles: true }));
          }
          const stepButton = event.target.closest(
            "[data-gallery-step],[data-zoom-step]",
          );
          if (stepButton)
            this.stepMedia(
              Number(
                stepButton.dataset.galleryStep || stepButton.dataset.zoomStep,
              ),
              stepButton.hasAttribute("data-zoom-step"),
            );
          const zoom = event.target.closest("[data-image-zoom]");
          if (zoom) {
            const media = zoom.closest("[data-product-media]");
            if (media) this.showMedia(media.dataset.productMedia);
            this.updateZoom(zoom);
          }
        },
        { signal },
      );
      const stage = this.querySelector(".av-product-gallery-stage");
      if (this.querySelector("[data-gallery-step]")) {
        let start;
        stage.addEventListener(
          "touchstart",
          (e) => {
            start = e.changedTouches[0].clientX;
          },
          { passive: true, signal },
        );
        stage.addEventListener(
          "touchend",
          (e) => {
            const dx = e.changedTouches[0].clientX - start;
            if (Math.abs(dx) > 60) this.stepMedia(dx < 0 ? 1 : -1);
          },
          { passive: true, signal },
        );
      }
      this.form.addEventListener(
        "submit",
        async (e) => {
          if (
            e.defaultPrevented ||
            (e.submitter && !e.submitter.matches("[data-add],[data-buy-now]"))
          )
            return;
          e.preventDefault();
          if (this.submitting || !this.form.reportValidity()) return;
          this.submitting = true;
          const buyNow = e.submitter?.hasAttribute("data-buy-now");
          const button = e.submitter || this.form.querySelector("[data-add]");
          button.disabled = true;
          button.classList.add("is-loading");
          const stickySubmit = this.querySelector("[data-sticky-add]");
          if (stickySubmit) {
            stickySubmit.disabled = true;
            stickySubmit.classList.add("is-loading");
          }
          this.form.setAttribute("aria-busy", "true");
          this.querySelector("[data-product-error]").hidden = true;
          try {
            await A.cart.add(this.form);
            if (buyNow) {
              await A.buyNowCheckout(() => location.assign(`${A.root}checkout`));
              return;
            }
            if (A.config.openCart) {
              const panel = document.getElementById("AvCart");
              if (panel)
                panel.open(document.querySelector("[data-cart-trigger]"));
              else
                A.navigate
                  ? A.navigate(A.config.cart)
                  : location.assign(A.config.cart);
            }
          } catch (error) {
            const out = this.querySelector("[data-product-error]");
            out.hidden = false;
            out.textContent = error.message;
          } finally {
            button.classList.remove("is-loading");
            this.querySelector("[data-sticky-add]")?.classList.remove(
              "is-loading",
            );
            this.form.setAttribute("aria-busy", "false");
            this.submitting = false;
            this.selectVariant(false);
          }
        },
        { signal },
      );
      this.form.querySelectorAll("[data-quantity-pack]").forEach((input) =>
        input.addEventListener(
          "change",
          () => {
            this.form.elements.quantity.value = input.value;
            this.selectVariant(false);
          },
          { signal },
        ),
      );
      const firstPack = this.form.querySelector("[data-quantity-pack]:checked");
      if (firstPack) this.form.elements.quantity.value = firstPack.value;
      this.selectVariant(false);
      this.querySelector("[data-sticky-add]")?.addEventListener(
        "click",
        () => this.form.requestSubmit(this.form.querySelector("[data-add]")),
        { signal },
      );
      const sticky = this.querySelector("[data-sticky-buy]");
      if (sticky && window.IntersectionObserver) {
        const original = this.form.querySelector("[data-add]");
        this.stickyObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === original)
              this.purchaseAboveViewport =
                !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            else this.footerVisible = entry.isIntersecting;
          });
          sticky.hidden = !this.purchaseAboveViewport || this.footerVisible;
        });
        this.stickyObserver.observe(original);
        const footer = document.querySelector(".av-footer");
        if (footer) this.stickyObserver.observe(footer);
      }
      const initialMedia = this.querySelector(
        "[data-product-media]:not([hidden])",
      );
      if (initialMedia) this.showMedia(initialMedia.dataset.productMedia);
    }
    selectVariant(updateUrl = true) {
      const variant = this.variants.find(
        (v) => String(v.id) === this.select.value,
      );
      if (!variant) return;
      const planSelect = this.form.elements.selling_plan;
      if (planSelect) {
        [...planSelect.options].forEach(
          (o) =>
            (o.disabled = o.value
              ? !(variant.plans || []).some((p) => String(p.id) === o.value)
              : variant.requires_selling_plan),
        );
        if (planSelect.selectedOptions[0]?.disabled)
          planSelect.value =
            [...planSelect.options].find((o) => !o.disabled)?.value || "";
      }
      const plan = variant.plans?.find(
        (p) => String(p.id) === planSelect?.value,
      );
      this.querySelector("[data-product-price]").textContent = A.money(
        plan?.price ?? variant.price,
      );
      const compare = this.querySelector("[data-product-compare]");
      compare.hidden = !(
        (plan?.compare_at_price ?? variant.compare_at_price) >
        (plan?.price ?? variant.price)
      );
      this.querySelector(".av-product-main-price")?.classList.toggle(
        "is-sale",
        !compare.hidden,
      );
      compare.textContent = A.money(
        plan?.compare_at_price ?? variant.compare_at_price ?? 0,
      );
      const button = this.form.querySelector("[data-add]");
      button.disabled =
        this.submitting ||
        !variant.available ||
        (variant.requires_selling_plan && !plan);
      button.textContent = variant.available
        ? A.strings.add
        : A.strings.soldOut;
      const price = plan?.price ?? variant.price;
      const comparePrice =
        plan?.compare_at_price ?? variant.compare_at_price ?? 0;
      const saving = this.querySelector("[data-product-savings]");
      if (saving) {
        saving.hidden = comparePrice <= price;
        const amount = Math.max(0, comparePrice - price);
        const value =
          saving.dataset.savingsFormat === "percent"
            ? `${comparePrice > 0 ? Math.round((amount / comparePrice) * 100) : 0}%`
            : A.money(amount);
        saving.querySelector("[data-savings-label]").textContent = [
          saving.dataset.savingsPrefix,
          value,
        ]
          .filter(Boolean)
          .join(" ");
      }
      this.querySelectorAll("[data-quantity-pack]").forEach((input) => {
        const q = Number(input.value),
          rule = variant.quantity_rule || { min: 1, increment: 1 };
        const invalid =
          q < rule.min ||
          (rule.max && q > rule.max) ||
          (q - rule.min) % rule.increment !== 0;
        input.disabled = invalid;
        input.closest("label").classList.toggle("is-disabled", !!invalid);
        const row = input.closest("label");
        const packSettings = row.closest(".av-quantity-packs").dataset;
        const percent = (value) => Math.min(100, Math.max(0, Number(value) || 0));
        const discount2 = q >= 2 ? percent(packSettings["packDiscount-2"]) : 0;
        const discount3 = q >= 3 ? percent(packSettings["packDiscount-3"]) : 0;
        const discount = Math.max(discount2, discount3);
        const packPrice = Math.round(price * q * (100 - discount) / 100);
        const reference = Math.max(comparePrice, price) * q;
        row.querySelector("[data-pack-price]").textContent = A.money(packPrice);
        const referenceLabel = row.querySelector("[data-pack-reference]");
        if (referenceLabel) {
          referenceLabel.hidden = reference <= packPrice;
          referenceLabel.textContent = A.money(reference);
        }
        const savingLabel = row.querySelector("[data-pack-saving]");
        savingLabel.hidden = reference <= packPrice;
        const saveText = packSettings.saveLabel ?? "Save";
        savingLabel.textContent = reference > packPrice
          ? `${saveText ? `${saveText} ` : ""}${Math.round((reference - packPrice) / reference * 100)}%`
          : "";
      });
      const packs = [...this.form.querySelectorAll("[data-quantity-pack]")];
      const selectedPack =
        packs.find((input) => input.checked && !input.disabled) ||
        packs.find((input) => !input.disabled);
      if (selectedPack) {
        selectedPack.checked = true;
        this.form.elements.quantity.value = selectedPack.value;
      }
      if (packs.length) {
        this.querySelector(".av-quantity-packs").hidden = false;
        this.querySelector(".av-product-quantity").hidden = !!selectedPack;
      }
      this.querySelectorAll("[data-variant-choice]").forEach((input) => {
        input.checked = input.value === String(variant.id);
      });
      const swatchPreview = this.querySelector("[data-current-swatch]");
      if (swatchPreview) {
        const source = document.getElementById(
          this.select.dataset.swatchSource,
        );
        const template =
          source &&
          [...source.querySelectorAll("template[data-variant-swatch]")].find(
            (node) => node.dataset.variantSwatch === String(variant.id),
          );
        const swatch = template?.content.querySelector(".av-variant-swatch");
        swatchPreview.replaceChildren(
          ...(swatch ? [swatch.cloneNode(true)] : []),
        );
      }
      const stickyVariant = this.querySelector("[data-sticky-variant]");
      if (stickyVariant && stickyVariant.value !== String(variant.id)) {
        stickyVariant.value = String(variant.id);
        stickyVariant.dispatchEvent(new Event("change", { bubbles: true }));
      }
      const buyButton = this.form.querySelector("[data-buy-now]");
      if (buyButton) buyButton.disabled = button.disabled;
      const stickyButton = this.querySelector("[data-sticky-add]");
      if (stickyButton) {
        stickyButton.disabled = button.disabled;
        stickyButton.textContent = button.textContent;
      }
      const stickyImage = this.querySelector(".av-sticky-image img");
      if (stickyImage && variant.preview_image) {
        stickyImage.src = variant.preview_image;
        stickyImage.removeAttribute("srcset");
        stickyImage.alt = variant.title || "";
      }
      const stickyPrice = this.querySelector("[data-sticky-price]");
      if (stickyPrice) stickyPrice.textContent = A.money(price);
      const stickyCompare = this.querySelector("[data-sticky-compare]");
      if (stickyCompare) {
        stickyCompare.hidden = comparePrice <= price;
        stickyCompare.textContent = A.money(comparePrice);
      }
      const qty = this.form.elements.quantity;
      const rule = variant.quantity_rule || { min: 1, increment: 1 };
      qty.min = rule.min || 1;
      qty.step = rule.increment || 1;
      if (rule.max) qty.max = rule.max;
      else qty.removeAttribute("max");
      if (Number(qty.value) < Number(qty.min)) qty.value = qty.min;
      if (variant.featured_media)
        this.showMedia(String(variant.featured_media.id));
      else if (variant.featured_image)
        this.showMedia(String(variant.featured_image.id));
      if (updateUrl && this.dataset.featured !== "true") {
        const url = new URL(location.href);
        url.searchParams.set("variant", variant.id);
        if (plan) url.searchParams.set("selling_plan", plan.id);
        else url.searchParams.delete("selling_plan");
        history.replaceState(history.state, "", url);
      }
      this.querySelectorAll("[data-option-label]").forEach(
        (n, i) => (n.textContent = variant.options?.[i] || ""),
      );
    }
    updateZoom(button) {
      const image = this.querySelector("[data-zoom-image]");
      if (!image || !button) return;
      image.src = button.dataset.zoomSrc;
      image.alt = button.querySelector("img")?.alt || "";
    }
    stepMedia(direction, imagesOnly = false) {
      const nodes = [...this.querySelectorAll("[data-product-media]")].filter(
        (n) => !imagesOnly || n.querySelector("[data-image-zoom]"),
      );
      if (!nodes.length) return;
      const index = nodes.findIndex(
        (n) => n.dataset.productMedia === this.activeMedia,
      );
      const next = nodes[(index + direction + nodes.length) % nodes.length];
      this.showMedia(next.dataset.productMedia);
      if (imagesOnly) this.updateZoom(next.querySelector("[data-image-zoom]"));
    }
    expandMobileGallery() {
      if (!this.gallery || !this.galleryMore || this.gallery.classList.contains("is-gallery-expanded")) return;
      const moveFocus = document.activeElement === this.galleryMore;
      this.gallery.classList.add("is-gallery-expanded");
      this.galleryMore.setAttribute("aria-expanded", "true");
      this.galleryMore.hidden = true;
      [...this.gallery.querySelectorAll("[data-product-media]")].slice(3).forEach((media, index) => {
        media.animate?.([{ opacity: 0, transform: "translateY(10px)" }, { opacity: 1, transform: "translateY(0)" }], {
          duration: A.duration?.(240) ?? 240, delay: Math.min(index * 35, 140), easing: "ease-out",
        });
      });
      if (moveFocus) {
        const firstRevealed = [...this.gallery.querySelectorAll("[data-product-media]")][3];
        const target = firstRevealed?.querySelector("button, a, video[controls]") || firstRevealed;
        if (target) {
          if (target === firstRevealed) target.setAttribute("tabindex", "-1");
          target.focus({ preventScroll: true });
        }
      }
    }
    showMedia(id) {
      if (!this.querySelector(`[data-product-media="${CSS.escape(id)}"]`))
        return;
      this.activeMedia = id;
      if (this.galleryMore && matchMedia("(max-width: 749px)").matches) {
        const mediaIndex = [...this.querySelectorAll("[data-product-media]")].findIndex((n) => n.dataset.productMedia === id);
        if (mediaIndex >= 3) this.expandMobileGallery();
      }
      const editorial = this.querySelector(".av-product-gallery--editorial");
      this.querySelectorAll("[data-product-media]").forEach((n) => {
        n.hidden = !editorial && n.dataset.productMedia !== id;
        if (n.hidden) {
          n.querySelectorAll("video").forEach((v) => v.pause());
          n.querySelectorAll("iframe").forEach((frame) => {
            if (frame.src) frame.src = frame.src;
          });
        }
      });
      const counter = this.querySelector("[data-gallery-counter]");
      const media = [...this.querySelectorAll("[data-product-media]")];
      if (counter)
        counter.textContent = `${media.findIndex((n) => n.dataset.productMedia === id) + 1} / ${media.length}`;
      this.querySelectorAll("[data-gallery-target]").forEach((b) =>
        b.setAttribute("aria-pressed", String(b.dataset.galleryTarget === id)),
      );
    }
    updateGallerySticky() {
      if (!this.gallery) return;
      const y = Math.max(0, scrollY);
      const delta = y - this.galleryScrollY;
      this.galleryScrollY = y;
      if (!matchMedia("(min-width: 990px)").matches) {
        this.gallery.style.removeProperty("--gallery-sticky-top");
        this.galleryTop = null;
        return;
      }
      const header = document.querySelector(
        'avenger-header[data-sticky="true"]',
      );
      const visibleHeader = header && !header.closest(".av-header-hidden");
      const top =
        24 +
        (visibleHeader
          ? Math.max(
              0,
              header.getBoundingClientRect().bottom,
              header.getBoundingClientRect().height || 0,
            )
          : 0);
      const height = this.gallery.getBoundingClientRect().height;
      const bottom = Math.min(top, innerHeight - height - 24);
      // A tall gallery scrolls naturally between its top and bottom sticky edges.
      // Short galleries remain below the visible header in either direction.
      this.galleryTop =
        height <= innerHeight - top - 24
          ? top
          : Math.max(bottom, Math.min(top, (this.galleryTop ?? top) - delta));
      this.gallery.style.setProperty(
        "--gallery-sticky-top",
        `${this.galleryTop}px`,
      );
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.stickyObserver?.disconnect();
      this.galleryResize?.disconnect();
      cancelAnimationFrame(this.galleryFrame);
    }
  }
  customElements.define("av-product", Product);
  const footerMenus = () => {
    if (innerWidth >= 750)
      document.querySelectorAll(".av-footer-menu").forEach((menu) => {
        menu.open = true;
      });
  };
  addEventListener("resize", footerMenus, { passive: true });
  document.addEventListener("change", (e) => {
    if (e.target.matches("[data-sort]")) e.target.form.requestSubmit();
    if (e.target.closest(".av-localization")) e.target.form.requestSubmit();
  });
})();
